import { motion } from 'framer-motion';
import HeroImage from '../assets/hero.png';

export default function Hero() {
	return (
    <section data-section='hero' className='scroll-m-20 mx-auto py-16 md:py-36 w-full md:max-w-2xl lg:max-w-4xl container section'>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <div className='max-w-xl'>
          <div className='flex gap-4 mb-4'>
            <motion.img className='shadow-lg rounded-full size-16' src={HeroImage} alt='Carlos Barbieri' whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}/>
            <motion.a href='https://linkedin.com/in/carlosdelviento23' target='_blank' rel='noopener noreferrer' className='flex md:justify-center items-center transition'   whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <div className='flex items-center'>
                <span className='inline-flex relative p-[1px] rounded-full overflow-hidden'>
                  <span className='absolute inset-[-1000%] bg-[conic-gradient(from_90deg_at_50%_50%,#51E4B8_0%,#21554E_50%,#51E4B8_100%)] animate-[spin_2s_linear_infinite]'></span>
                  <div className='inline-flex justify-center items-center bg-green-100 dark:bg-gray-800 backdrop-blur-3xl px-3 py-1 rounded-full w-full text-green-800 text-sm dark:text-white/80 whitespace-nowrap cursor-pointer'>
                    Available for work
                  </div>
                </span>
              </div>
            </motion.a>
          </div>
       
        <h1 className='font-bold text-4xl sm:text-5xl tracking-tight'>
          Hi I&apos;m Carlos Barbieri
        </h1>
        <p className='mt-6 text-xl text dark:[&>strong]:text-accent-light [&>strong]:font-semibold dark:text-gray-300'>
          I am a full stack developer with a passion for creating beautiful and
          functional websites, focused on both the backend and frontend.
          Currently, I work as a Backend Developer in a company in Montevideo,
          Uruguay, where I mainly use Java and Spring Boot. I have experience
          with technologies such as React, PostgreSQL, MongoDB, and more.
          <strong className='text-accent'>
            Java Developer and Programmer Analyst student
          </strong> from Montevideo, Uruguay. Specialized in backend development with
          strong frontend analysis.
        </p>
        <nav className='flex flex-wrap gap-4 mt-8'>
          <a href='mailto:carlosdelviento23@gmail.com' target='_blank' rel='noopener noreferrer' role='link' className='inline-flex justify-center items-center gap-2 border-gray-300 hover:border-gray-700 dark:hover:border-gray-300 dark:border-gray-600 bg-gray-100 hover:bg-gray-900 dark:hover:bg-gray-100 active:bg-black dark:bg-gray-800 px-4 py-1 border rounded-full focus-visible:ring focus-visible:ring-yellow-500/80 focus-visible:ring-white focus-visible:ring-offset-2 max-w-fit text-gray-800 text-md hover:text-white dark:hover:text-black dark:text-white transition group focus:outline-none focus-visible:outline-none'>
            <svg className='size-4' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor' fill='none' strokeLinecap='round' strokeLinejoin='round'>
              <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
              <path d='M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5'></path>
              <path d='M3 6l9 6l9 -6'></path>
              <path d='M15 18h6'></path>
              <path d='M18 15l3 3l-3 3'></path>
            </svg>
            Contact
          </a>
          <a href='https://linkedin.com/in/carlosdelviento23' target='_blank' rel='noopener noreferrer' role='link' className='inline-flex justify-center items-center gap-2 border-gray-300 hover:border-gray-700 dark:hover:border-gray-300 dark:border-gray-600 bg-gray-100 hover:bg-gray-900 dark:hover:bg-gray-100 active:bg-black dark:bg-gray-800 px-4 py-1 border rounded-full focus-visible:ring focus-visible:ring-yellow-500/80 focus-visible:ring-white focus-visible:ring-offset-2 max-w-fit text-gray-800 text-md hover:text-white dark:hover:text-black dark:text-white transition group focus:outline-none focus-visible:outline-none'>
            <svg className='size-4' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor' fill='none' strokeLinecap='round' strokeLinejoin='round'>
              <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
              <path d='M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z'></path>
              <path d='M8 11l0 5'></path>
              <path d='M8 8l0 .01'></path>
              <path d='M12 16l0 -5'></path>
              <path d='M16 16v-3a2 2 0 0 0 -4 0'></path>
            </svg>
            LinkedIn
          </a>
        </nav>
        </div>
      </motion.div>
    </section>
  )
}
